export function capitalizeFirstLetters(string) {
  const noCapWords = [
      'a',
      'an',
      'the',
      'for',
      'and',
      'nor',
      'but',
      'or',
      'yet',
      'so',
      'at',
      'around',
      'by',
      'after',
      'along',
      'for',
      'from',
      'of',
      'on',
      'to',
      'with',
      'without'
  ]

  return string
    .split(' ')
    .map(string => !noCapWords.includes(string.toLowerCase()) ? string.trim().charAt(0).toUpperCase() + string.slice(1) : string)
    .join(' ')
}
